import React, { FC, useEffect } from 'react';

type CountDownCallBack = (value: (prevCountDown: number) => number) => void;

interface ITimerProps {
  countDown: number;
  runTimer: boolean;
  setCountDownCallback: CountDownCallBack;
  setRunTimerCallback: (value: boolean) => void;
}

const Timer: FC<ITimerProps> = props => {
  const { countDown, setCountDownCallback, runTimer, setRunTimerCallback } = props;
  const MINUTE = 60;
  const TIMER_TICK_MS = 1000;

  useEffect(() => {
    let timerId: number;

    if (runTimer) {
      setCountDownCallback(() => MINUTE * countDown);
      timerId = window.setInterval(() => {
        setCountDownCallback(prevCountDown => prevCountDown - 1);
      }, TIMER_TICK_MS);
    }

    return () => clearInterval(timerId);
  }, [setCountDownCallback, runTimer]);

  useEffect(() => {
    if (countDown < 0 && runTimer) {
      setRunTimerCallback(false);
      setCountDownCallback(() => 0);
    }
  }, [setCountDownCallback, setRunTimerCallback, countDown, runTimer]);

  useEffect(() => {
    if (!runTimer) {
      setRunTimerCallback(true);
    }
  }, []);

  const seconds = String(countDown % MINUTE).padStart(2, '0');
  const minutes = String(Math.floor(countDown / MINUTE)).padStart(2, '0');

  return (
    <>
      {minutes}:{seconds}
    </>
  );
};

export { Timer };
